import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
// import { environment } from '../../environment/envirnoment.dev';
import { environment } from '../../environment/environment';
@Injectable({
  providedIn: 'root'
})
export class LeadService  {
  private responseData = new BehaviorSubject<any>(null);
  responseData$ = this.responseData.asObservable();

  private http: HttpClient = inject(HttpClient);

  private API_URL = environment.apiUrl;


  getUserDetails(userId: string): Observable<any> {
    const url = `${this.API_URL}/v1/sunlife/userDetail?userId=${userId}`;
    return this.http.get(url);
  }

  submitLead(leadData: any): Observable<any> {
    const url = `${this.API_URL}/v1/sunlife/leads`;
    return this.http.post(url, leadData);
  }

  // Phone verification OTP API integration
  sendOtp(payload: any): Observable<any> {
    const url = `${this.API_URL}/v3/user/send-otp`;
    const body = payload;
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'platform': '1',
      'timezone': '0',
      'language': 'en',
      'api_key': '1234'
    };
    return this.http.post(url, body, { headers });
  }

  // OTP verification API integration
  verifyOtp(payload: any): Observable<any> {
    const url = `${this.API_URL}/v2/user/verify-otp`;
    const body = payload;
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'platform': '1',
      'timezone': '0',
      'language': 'en',
      'api_key': '1234'
    };
    return this.http.post(url, body, { headers });
  }

  // Zalo OTP API integration
  sendZaloOtp(payload: any): Observable<any> {
    const url = `${this.API_URL}/v2/user/zalo/send-otp`;
    const body = payload;
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'platform': '1',
      'timezone': '0',
      'language': 'en',
      'api_key': '1234'
    };
    return this.http.post(url, body, { headers });
  }
  premiumCalculation(payload:any):Observable<any>{
    const url = `https://insurance-dev.livwell.asia/livwell/api/v1/leads/premium-calculator`;
    return this.http.post(url, payload);
  }
   setResponseData(data: any) {
    this.responseData.next(data);
  }

  getResponseData() {
    return this.responseData.value;
  }
}
